import {StandaloneAccount} from "../../../models/StandaloneAccount";
import {HeldAwayAccountSummary, LegalAgreement} from "../../../models/InvestmentProgram";
import AccountsTable from "../../InEstate/AccountsTable";
import React from "react";
import {NO_OP} from "../../../../constants/common";
import {AccordionItemWithActionMenu} from "../../../../components";
import {COLOR_ASSETS_ACCOUNTS} from "../../../../constants/colors";
import {
    calculateInEstateInvestableTotalValueForAccounts,
    calculateInEstateTotalMarketValueForAccounts
} from "../../common/AssetSummaryCalculator";
import {AssetAccordionHeader} from "../../common/AssetAccordionHeader";
import {formatCurrency} from "../../../../utils/format";
import {AccordionItemIds} from "../constants";
import {DropResult} from "react-beautiful-dnd";
import {PartiallyOwnedLegalAgreement} from "../../../models/PartiallyOwnedInvestmentAccount";
import {BankingAccountsSummary} from "../../../models/BankingAccounts";

type AccountsProps = {
    profileId: string,
    accounts: StandaloneAccount[],
    legalAgreements: LegalAgreement[],
    heldAwayAccounts: HeldAwayAccountSummary[],
    bankingAccounts: BankingAccountsSummary[],
    partiallyOwnedInvestmentAccounts: PartiallyOwnedLegalAgreement[],
    captureAccountsOrder: ({source, destination}: DropResult) => void
}

const Accounts = ({
                      profileId,
                      accounts,
                      legalAgreements,
                      heldAwayAccounts,
                      partiallyOwnedInvestmentAccounts,
                      bankingAccounts,
                      captureAccountsOrder
                  }: AccountsProps) => {

    if (accounts.length === 0 && legalAgreements.length === 0 && heldAwayAccounts.length === 0 && partiallyOwnedInvestmentAccounts.length === 0
    && bankingAccounts.length === 0) {
        return <></>;
    }

    return (
        <AccordionItemWithActionMenu
            uuid={AccordionItemIds.accounts}
            expandable={false}
            accentColor={COLOR_ASSETS_ACCOUNTS}
            HeaderComponent={({expanded}) => {
                const totalInEstateMarketValue = calculateInEstateTotalMarketValueForAccounts(accounts, legalAgreements, heldAwayAccounts, partiallyOwnedInvestmentAccounts,bankingAccounts);
                const totalInEstateInvestableValue = calculateInEstateInvestableTotalValueForAccounts(accounts, legalAgreements, heldAwayAccounts,bankingAccounts);
                return <AssetAccordionHeader
                    expanded={expanded}
                    title="Accounts"
                    formattedTotalInvestableValue={formatCurrency(totalInEstateInvestableValue)}
                    formattedTotalPresentValue={formatCurrency(totalInEstateMarketValue)}
                    gridClassName={"assets-grid"}
                    showChevron={false}
                />;
            }}
        >
            <AccountsTable
                profileId={profileId}
                onDeleteAssetClick={NO_OP}
                standaloneAccounts={accounts}
                legalAgreements={legalAgreements}
                heldAwayAccounts={heldAwayAccounts}
                partiallyOwnedInvestmentAccounts={partiallyOwnedInvestmentAccounts}
                bankingAccounts={bankingAccounts}
                hideActionMenu={true}
                isDraggable={true}
                captureAccountsOrder={captureAccountsOrder}
            />
        </AccordionItemWithActionMenu>
    )
}

export default Accounts;